<template lang="pug">
footer.footer
    .container
        .logo
            img(src="@/assets/divergancy_logo.svg" alt="DIVƎRGANCY Models - Logo")
        .address
            p
                b DIVƎRGANCY
            p Weserstr. 47 <br>45136 Essen
        nav#footer-menu(v-if="items && items.length" aria-label="Footermenü")
            tree-menu(
                :items="items",
                :max-depth="1",
                :allow-multiple-active-items="true",
                :delay="100"
            )
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>
@import "~bulma/sass/utilities/mixins"
@import '~@/assets/sass/variables'
footer
    background-color: $primary
    color: #fff
    position: relative
    .container
        padding: 25px
        display: flex
        justify-content: space-around
        .logo, .address
            width: 20%
        +mobile
            flex-direction: column
            .logo, .address
                width: 100%
            .address
                margin-bottom: 10px
    nav#footer-menu ::v-deep
        a
            color: #fff
            ul
                & > li
                    text-align: center
                    a
                        display: block
                        padding: 10px 20px
                +desktop
                    display: flex
                    justify-content: center
                    & > li
                        // flex-grow: 1
                        // flex-basis: 100%
                        text-transform: uppercase
                        border-right: 1px solid $primary
                        &:last-child
                            border-right: none
                        a
                            display: flex
                            justify-content: center
                            align-items: center
                        &.visible
                            a
                                background-color: lighten($primary, 10%)
        div#va-footer
            font-size: .8rem
            padding: 4px
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                font-size: .9rem
                position: absolute
                bottom: 100%
                color: #4c4c4c
                width: 100%
                text-align: center
</style>
